export const SurchargeV2ToggleOptions: { [key: string]: string } = {
  No: "V1",
  Yes: "V2",
};
